export const memberKeys = {
  all: () => ['members'] as const,
  list: () => [...memberKeys.all(), 'list'] as const,
  roles: () => [...memberKeys.all(), 'roles'] as const,
  invitations: () => [...memberKeys.all(), 'invitations'] as const,
}
